<div class="order-book-linear">
	<div class="titles">
		<span
			class="title ask"
			[tuiSkeleton]="isLoading()"
			>{{ 'orderBook.askBuy' | translate }}</span
		>
		<span
			class="title bid"
			[tuiSkeleton]="isLoading()"
			>{{ 'orderBook.bidSell' | translate }}</span
		>
	</div>
	<div class="lines">
		<div
			class="line ask"
			[tuiSkeleton]="isLoading()"
			[style.width]="percentAskSize() + '%'"
		></div>
		<div
			class="line bid"
			[tuiSkeleton]="isLoading()"
			[style.width]="percentBidSize() + '%'"
		></div>
	</div>
	<div class="values">
		<tui-badge
			appearance="negative"
			class="item ask"
			[tuiSkeleton]="isLoading()"
		>
			<span
				class="value"
				[appAnimatedNumber]="orderBook()?.ask | price: false"
			></span>
			<span
				class="count"
				[appAnimatedNumber]="orderBook()?.askSize | price: false"
			></span>
		</tui-badge>

		<div
			class="item item-diff"
			[tuiSkeleton]="isLoading()"
		>
			<span
				class="value"
				[appAnimatedNumber]="orderBook()?.diffPercent | percent"
			></span>
		</div>

		<tui-badge
			appearance="positive"
			class="item bid"
			[tuiSkeleton]="isLoading()"
		>
			<span
				class="value"
				[appAnimatedNumber]="orderBook()?.bid | price: false"
			></span>
			<span
				class="count"
				[appAnimatedNumber]="orderBook()?.bidSize | price: false"
			></span>
		</tui-badge>
	</div>
</div>
